import React from 'react';
import { companyInfo } from '../../constants/data';

const About = () => {
  return (
    <div className="py-5">
      <div className="container-fluid">
        {/* Hero Section */}
        <div className="row align-items-center mb-5">
          <div className="col-lg-6">
            <h1 className="display-4 fw-bold mb-4">Know Us</h1>
            <p className="lead text-muted mb-4">At {companyInfo.name}, we're more than just a service provider - we're your partner in industrial excellence.</p>
            <div className="d-flex gap-3">
              <div className="text-center">
                <h3 className="text-primary fw-bold">10+</h3>
                <p className="text-muted">Years Experience</p>
              </div>
              <div className="text-center">
                <h3 className="text-primary fw-bold">500+</h3>
                <p className="text-muted">Happy Clients</p>
              </div>
              <div className="text-center">
                <h3 className="text-primary fw-bold">24/7</h3>
                <p className="text-muted">Service Support</p>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="bg-primary text-white p-5 rounded">
              <h3 className="mb-3">Our Mission</h3>
              <p>To provide reliable, efficient, and cost-effective forklift solutions that empower businesses to achieve their operational goals with maximum safety and minimum downtime.</p>
            </div>
          </div>
        </div>

        {/* Company Story */}
        <div className="row mb-5">
          <div className="col-12">
            <div className="card border-0 shadow-sm">
              <div className="card-body p-5">
                <h2 className="mb-4">Our Story</h2>
                <p className="lead mb-4">
                  Founded with a vision to revolutionize material handling solutions, {companyInfo.name} has grown from a small workshop to one of the most trusted names in forklift services across Bhopal.
                </p>
                <p>
                  Our journey began with a simple goal: to provide honest, reliable service in an industry where downtime means lost revenue. Today, we serve businesses across manufacturing, warehousing, logistics, and construction sectors.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Values */}
        <div className="row mb-5">
          <div className="col-12 text-center mb-5">
            <h2 className="display-5 fw-bold">Our Values</h2>
          </div>
          <div className="col-md-4 mb-4">
            <div className="text-center p-4">
              <div className="bg-primary bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{width: '80px', height: '80px'}}>
                <i className="bi bi-shield-check text-primary fs-2"></i>
              </div>
              <h4>Reliability</h4>
              <p className="text-muted">We stand by our word. Every service commitment is backed by our reputation.</p>
            </div>
          </div>
          <div className="col-md-4 mb-4">
            <div className="text-center p-4">
              <div className="bg-primary bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{width: '80px', height: '80px'}}>
                <i className="bi bi-award text-primary fs-2"></i>
              </div>
              <h4>Excellence</h4>
              <p className="text-muted">We deliver superior quality in every service, using only genuine parts and certified technicians.</p>
            </div>
          </div>
          <div className="col-md-4 mb-4">
            <div className="text-center p-4">
              <div className="bg-primary bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{width: '80px', height: '80px'}}>
                <i className="bi bi-people text-primary fs-2"></i>
              </div>
              <h4>Partnership</h4>
              <p className="text-muted">We work with you as partners, understanding your needs and providing tailored solutions.</p>
            </div>
          </div>
        </div>

        {/* Team Commitment */}
        <div className="bg-light rounded p-5">
          <div className="row align-items-center">
            <div className="col-lg-8">
              <h2 className="mb-3">Our Team Commitment</h2>
              <p className="mb-0">
                Our team of certified technicians and service engineers undergoes regular training to stay updated with the latest forklift technologies and safety standards. We believe in continuous improvement and customer satisfaction.
              </p>
            </div>
            <div className="col-lg-4 text-lg-end mt-3 mt-lg-0">
              <a href="/contact" className="btn btn-primary btn-lg">
                Meet Our Team <i className="bi bi-arrow-right ms-2"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;